module.exports = __webpack_public_path__ + "static/img/s3.4fc82779.png";